import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-kind-choice" }
const _hoisted_2 = { class: "login-kind-choice__actions" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import type { PublicLoginKind } from '@/api/publicLogin'


export default /*@__PURE__*/_defineComponent({
  __name: 'PublicLoginKindChoice',
  props: {
    kinds: { default: () => ['member', 'seller'] },
    busy: { type: Boolean }
  },
  emits: ["pick", "reset"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "login-kind-choice__lead" }, "같은 아이디가 여러 계정에 있습니다.", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "login-kind-choice__ask" }, "어느 계정으로 들어가시겠습니까?", -1)),
    _createElementVNode("div", _hoisted_2, [
      (__props.kinds.includes('member'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "login-kind-choice__btn login-kind-choice__btn--member",
            disabled: __props.busy,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('pick', 'member')))
          }, " 일반회원 ", 8, _hoisted_3))
        : _createCommentVNode("", true),
      (__props.kinds.includes('seller'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "login-kind-choice__btn login-kind-choice__btn--seller",
            disabled: __props.busy,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('pick', 'seller')))
          }, " 판매업체 ", 8, _hoisted_4))
        : _createCommentVNode("", true),
      (__props.kinds.includes('admin'))
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "login-kind-choice__btn login-kind-choice__btn--admin",
            disabled: __props.busy,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('pick', 'admin')))
          }, " 관리자 ", 8, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "login-kind-choice__reset",
      disabled: __props.busy,
      onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('reset')))
    }, " 다시 입력 ", 8, _hoisted_6)
  ]))
}
}

})